/**
 * 한국 시간 기준 현재 날짜를 가져옵니다.
 * @returns {Date} 한국 시간 기준 현재 날짜
 */
export function getKoreanDate() {
  const now = new Date();
  // UTC 시간에 9시간을 더해서 한국 시간으로 변환
  const koreaTime = new Date(now.getTime() + 9 * 60 * 60 * 1000);
  return koreaTime;
}

/**
 * 한국 시간 기준 현재 날짜를 YYYY-MM-DD 형식으로 반환합니다.
 * @returns {string} YYYY-MM-DD 형식의 날짜 문자열
 */
export function getKoreanDateString() {
  const koreaDate = getKoreanDate();
  return koreaDate.toISOString().split('T')[0];
}

/**
 * 한국 시간 기준 오늘 날짜를 API 요청용으로 반환합니다.
 * @returns {string} YYYY-MM-DD 형식의 오늘 날짜
 */
export function getTodayForAPI() {
  return getKoreanDateString();
}

export function getBusinessDays(count) {
  const dates = [];
  const today = getKoreanDate();
  
  // 한국 시간 기준 오늘 날짜를 YYYY-MM-DD 형식으로 변환하고 다시 Date 객체로 생성
  // 이렇게 하면 시간 정보 없이 순수한 날짜만 다룰 수 있음
  const todayStr = today.toISOString().split('T')[0];
  let currentDate = new Date(todayStr + 'T00:00:00.000Z');
  
  // 오늘이 주말이면 가장 가까운 금요일로 이동
  const dayOfWeek = currentDate.getUTCDay();
  if (dayOfWeek === 0) {
    // 일요일이면 2일 전 (금요일)
    currentDate.setUTCDate(currentDate.getUTCDate() - 2);
  } else if (dayOfWeek === 6) {
    // 토요일이면 1일 전 (금요일)
    currentDate.setUTCDate(currentDate.getUTCDate() - 1);
  }

  while (dates.length < count) {
    // 주말 제외 (0: 일요일, 6: 토요일)
    const dayOfWeek = currentDate.getUTCDay();
    if (dayOfWeek !== 0 && dayOfWeek !== 6) {
      dates.push(formatYYYYMMDDFromUTC(currentDate));
    }
    currentDate.setUTCDate(currentDate.getUTCDate() - 1);
  }

  // 최신 날짜가 먼저 오도록 (내림차순)
  return dates;
}

function formatYYYYMMDDFromUTC(date) {
  const year = date.getUTCFullYear();
  const month = String(date.getUTCMonth() + 1).padStart(2, '0');
  const day = String(date.getUTCDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

/**
 * 한국 시간 기준 오늘 날짜를 YYYY-MM-DD 형식으로 반환합니다.
 * 주말인 경우 가장 가까운 금요일을 반환합니다.
 * @returns {string} YYYY-MM-DD 형식의 오늘 날짜 (또는 가장 가까운 영업일)
 */
export function getTodayStr() {
  const today = getKoreanDate();
  const todayStr = today.toISOString().split('T')[0];
  let currentDate = new Date(todayStr + 'T00:00:00.000Z');
  
  // 오늘이 주말이면 가장 가까운 금요일로 이동
  const dayOfWeek = currentDate.getUTCDay();
  if (dayOfWeek === 0) {
    // 일요일이면 2일 전 (금요일)
    currentDate.setUTCDate(currentDate.getUTCDate() - 2);
  } else if (dayOfWeek === 6) {
    // 토요일이면 1일 전 (금요일)
    currentDate.setUTCDate(currentDate.getUTCDate() - 1);
  }
  
  return formatYYYYMMDDFromUTC(currentDate);
}
